module.exports = __webpack_public_path__ + "static/media/BuildingsStory.eb11ad5a.svg";